import React from "react";
import CircularProgress from "../../../CircularProgress/CircularProgress";
import style from "./styles.module.scss";

export const LoadingMessage = ({ text, className = "" }) => (
  <div className={`${style.loadingMessage} ${className}`}>
    <CircularProgress sm style={{ margin: "0px" }} />
    <span>{text}</span>
  </div>
);

export const GetRiskClassName = (risk) => {
  const riskLabel = risk.toLowerCase();
  switch (riskLabel) {
    case "low":
    case "conservative":
      return "buy";

    case "medium":
    case "moderate":
      return "warning";

    case "high":
    case "agressive":
      return "danger";
    default:
      break;
  }
};

export const IsCustodyBalance = (type) => type == "Custody" || type == "LocalCustody";
